import React from "react";
import {Layout} from "antd";
import Header from "../components/headerComponent/header";
import Footer from "../components/footerComponent/footer";
import Homeworks from "../components/teacherComponent/homeworksComponent";

export default function HomeworksPage() {
    return (
        <Layout>
            <Header/>
            <Homeworks/>
            <Footer/>
        </Layout>
    );
};